import { render } from "./ApplicationLogoWhite.vue?vue&type=template&id=476cd338"
const script = {}

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Layout/ApplicationLogoWhite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "476cd338"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('476cd338', __exports__)) {
    console.log('reload')
    api.reload('476cd338', __exports__)
  }
  
  module.hot.accept("./ApplicationLogoWhite.vue?vue&type=template&id=476cd338", () => {
    console.log('re-render')
    api.rerender('476cd338', render)
  })

}


export default __exports__